<template>
    <div class="filter-box">
        <div class="search-box">
            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                <input type="text"
                       v-model="search_text"
                       :placeholder="trans[locale].search_placeholder"
                       class="form-control">
                <button type="button" class="btn"
                        @click="keywordSearch"><i aria-hidden="true" class="fa fa-search"></i></button>
            </div>
        </div>
        <div class="d-inline-block align-top mb-2">
            <multiselect
                    :options="year_options"
                    v-model="selected_year"
                    track-by="key"
                    label="name"
                    :preselect-first="true"
                    :searchable="false"
                    :allow-empty="false"
                    :close-on-select="true"
                    :show-labels="false"
                    :multiple="false"
            >
            </multiselect>
        </div>
        <div class="d-inline-block align-top mb-2">
            <multiselect
                    :options="category_options"
                    v-model="selected_category"
                    track-by="key"
                    label="name"
                    :preselect-first="true"
                    :searchable="false"
                    :allow-empty="false"
                    :close-on-select="true"
                    :show-labels="false"
                    :multiple="false"
            >
            </multiselect>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PickerOption",
        data() {
            return Object.assign({
                trans: {
                    'zh-HK': {
                        search_placeholder: '搜尋',
                    },
                    'en': {
                        search_placeholder: 'Search',
                    },
                },
                search_text: '',
                selected_year: {},
                selected_category: {},
            }, { locale: window.locale })
        },
        beforeMount() {
            window.eventHub.$off('update-keyword', (keyword) => {
                this.search_text = keyword;
            });
        },
        mounted() {
            _.forEach(this.year_options, (row) => {
                if (row.key == this.initial_year)
                {
                    this.selected_year = row;
                }
            });
            this.selected_category = _.first(this.category_options);
            this.fetchOptions();
            window.eventHub.$on('update-keyword', (keyword) => {
                this.search_text = keyword;
            });
        },
        props: {
            initial_year: {
                required: false,
                type: String,
                default: '',
            },
            year_options: {
                required: false,
                type: Array,
                default: ()=>{
                    return [];
                }
            },
            category_options: {
                required: false,
                type: Array,
                default: ()=>{
                    return [];
                }
            },
        },
        watch: {
            selected_year() {
                window.eventHub.$emit('show-media-listing', false);
                this.fetchOptions();
            },
            selected_category() {
                window.eventHub.$emit('show-media-listing', false);
                this.fetchOptions();
            },
            searchTxt() {
                this.fetchOptions();
            },
        },
        methods: {
            fetchOptions: _.debounce(function() {
                let self = this;
                let option_param = {
                    year: self.selected_year,
                    category: self.selected_category,
                    keyword: self.search_text,
                    query_str: 'year=' + self.selected_year.key + '&keyword=' + self.search_text,
                }
                if (!_.isUndefined(self.$parent.show_media_selector) && self.$parent.show_media_selector)
                {
                    window.eventHub.$emit('retrieve-media-list', option_param);
                } else {
                    window.eventHub.$emit('update-keyword', self.search_text);
                    window.eventHub.$emit('retrieve-album-list', option_param);
                }
            }, 500),
            keywordSearch() {
                this.fetchOptions();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/DigitalChannelMediaPicker/PickerOption.vue